import React from 'react';
import { EmailLeadFormModal } from '@dmm/lib-react-ui-components';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import { syncTranslationElements } from '../../../utils/translations/translationsSync';
import { useBdpForm } from '../MainContent/bdpController/useBdpForm';
import { nil } from '../../../utils/runOnceHelper';
import { bdpFormMessages } from '../utils/bdpParsers';

const DisplayedLeadFormModal = ({
  onClose,
  intl,
  listing,
  portal,
  onSuccess,
  onError
}) => {
  const leadTranslate = syncTranslationElements(intl);
  const idPrefix = 'modal-lead-form-';
  const showCloseButton = true;
  const { leadFormFields, leadFormHandlers, invalidFields } = useBdpForm(
    listing,
    portal,
    leadTranslate,
    idPrefix,
    onSuccess,
    onError,
    showCloseButton
  );
  const { sellerNameField, nameField, emailField, phoneField, textField } =
    leadFormFields;
  const { handleSubmit, showSuccess, showError } = leadFormHandlers;
  const { messages, t } = leadTranslate;
  const emailFormMessages = bdpFormMessages(t, messages);
  const doClose = () => {
    onClose();
  };
  return (
    <div className="email-lead-form-modal">
      <EmailLeadFormModal
        show={true}
        onClose={doClose}
        sellerName={sellerNameField}
        name={nameField}
        email={emailField}
        phone={phoneField}
        textarea={textField}
        invalidFields={invalidFields}
        showSuccessMessage={showSuccess}
        showErrorMessage={showError}
        onSubmit={handleSubmit}
        {...emailFormMessages}
      />
    </div>
  );
};

const BDPEmailLeadFormModal = ({
  show,
  portal,
  onClose,
  intl,
  listing,
  onSuccess = nil,
  onError = nil
}) => {
  if (!show) {
    return null;
  }
  return (
    <DisplayedLeadFormModal
      onClose={onClose}
      intl={intl}
      listing={listing}
      portal={portal}
      onSuccess={onSuccess}
      onError={onError}
    />
  );
};

const EmailModalPropTypes = {
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
    locale: PropTypes.string
  }).isRequired,
  listing: listingPropTypes.isRequired,
  portal: PropTypes.string
};

BDPEmailLeadFormModal.propTypes = {
  ...EmailModalPropTypes,
  show: PropTypes.bool
};
DisplayedLeadFormModal.propTypes = {
  ...EmailModalPropTypes
};

export default injectIntl(BDPEmailLeadFormModal);
